module.exports = __webpack_public_path__ + "static/media/logo.24ae0244.svg";